import React from "react";
import { HashRouter as Router } from "react-router-dom";
import AnimatedRoutes from "./AnimatedRoutes";

export function App(this: any): JSX.Element {
  return (
    <div>
      <Router>
        <AnimatedRoutes />
      </Router>
    </div>
  );
}
